import { Component, EventEmitter, OnDestroy, Output } from '@angular/core';
import { Account, Customer } from '@inyova/models';

import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import * as fromAppRoot from '@app/app.reducers';

import { LanguageService } from '@shared/services/language.service';

@Component({
  selector: 'app-guarantee-shield',
  templateUrl: './guarantee-shield.component.html',
  styleUrls: ['./guarantee-shield.component.scss'],
  standalone: false
})
export class GuaranteeShieldComponent implements OnDestroy {
  protected readonly onDestroy$ = new Subject<void>();
  @Output() guaranteeModal = new EventEmitter<boolean>();
  tuvLanguage: string;
  customer: Customer;
  currentAccount: Account;

  constructor(
    private languageService: LanguageService,
    private store: Store
  ) {
    this.tuvLanguage = this.languageService.getRedirectLanguage();

    this.store
      .select(fromAppRoot.selectCustomerAndCurrentAccount)
      .pipe(takeUntil(this.onDestroy$))
      .subscribe((value) => {
        if (!value || !value.customer || !value.customer.email || !value.currentAccountDetail?.onboarding_step) {
          return;
        }

        this.customer = value.customer;
        this.currentAccount = value.currentAccountDetail;
      });
  }

  openGuaranteeModal(): void {
    this.guaranteeModal.emit();
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }
}
